import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { Tour } from '#domain/model/Tour.ts';

import type { RootState } from '../configuration/setup/store';

export type WidgetState = {
    widgetId?: string;
    visibleWidgets: string[];
    selectedAssetId?: string;
    selectedMapMarkerId?: string;
    selectedTour?: Tour;
};

const initialState: WidgetState = {
    widgetId: undefined,
    visibleWidgets: [],
    selectedAssetId: undefined,
    selectedMapMarkerId: undefined,
    selectedTour: undefined,
};

const widgetSlice = createSlice({
    name: 'widget',
    initialState,
    reducers: {
        widgetIdSet: (state, action: PayloadAction<string | undefined>) => {
            state.widgetId = action.payload;
        },
        visibleWidgetsSet: (state, action: PayloadAction<string[]>) => {
            state.visibleWidgets = action.payload;
        },
        assetIdSelected: (state, action: PayloadAction<string>) => {
            state.selectedAssetId = action.payload;
        },
        mapMarkerSelected: (state, action: PayloadAction<string | undefined>) => {
            state.selectedMapMarkerId = action.payload;
        },
        tourSelected: (state, action: PayloadAction<Tour | undefined>) => {
            state.selectedTour = action.payload;
        },
    },
});

export const { assetIdSelected, mapMarkerSelected, tourSelected, widgetIdSet, visibleWidgetsSet } = widgetSlice.actions;

export const selectWidgetId = (state: RootState): string | undefined => state.widget.widgetId;
export const selectVisibleWidgets = (state: RootState): string[] => state.widget.visibleWidgets;
export const selectIsWidgetVisible = (state: RootState): boolean => {
    const widgetId = selectWidgetId(state);
    const visibleWidgets = selectVisibleWidgets(state);
    return widgetId !== undefined && visibleWidgets.includes(widgetId);
};
export const selectSelectedAssetId = (state: RootState) => state.widget.selectedAssetId;
export const selectSelectedMapMarkerId = (state: RootState) => state.widget.selectedMapMarkerId;
export const selectSelectedTour = (state: RootState) => state.widget.selectedTour;

export default widgetSlice.reducer;
